import { z } from "zod";

// Define form schema
export const agentFormSchema = z.object({
  title: z.string().min(1, "Title is required"),
  description: z.string().optional(),
  instructions: z.string().optional(),
  restrictions: z.string().optional(),
  notification_email: z.string().email("Invalid email").optional().or(z.literal("")),
  notification_webhook_url: z.string().url("Please enter a valid webhook URL").optional().or(z.literal("")),
  is_active: z.boolean().default(true),
  welcome_message: z.string().optional(),
  thank_you_message: z.string().optional(),
  agent_name: z.string().optional(),
  conversation_starters: z.array(z.string()).optional(),
  category: z.string().optional().default("unknown"),
  banner: z.string().optional().nullable(), // Make banner nullable to match database
});

export type AgentFormValues = z.infer<typeof agentFormSchema>;
